/* eslint-disable eqeqeq */
import { useState } from "react";
import { HiArrowLeft } from "react-icons/hi";
import { Link, useNavigate } from "react-router-dom";
import { isValidEmail } from "../../../../utils/functions";
import { showErrorToast } from "../../../../utils/toast";
import { useMutation } from "react-query";
import { forgetPassword } from "../../../../api/user";

const key = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="54"
    height="53"
    viewBox="0 0 54 53"
    fill="none"
  >
    <circle cx="27" cy="26.5" r="26.5" fill="#00EFC1" fill-opacity="0.1" />
    <circle cx="27" cy="26.5" r="21.5" fill="#00EFC1" fill-opacity="0.3" />
    <path
      d="M31.1706 21.4167L35.2539 17.3333M37.5872 15L35.2539 17.3333L37.5872 15ZM26.3756 26.2117C26.978 26.806 27.4568 27.5137 27.7846 28.2939C28.1124 29.0741 28.2826 29.9115 28.2854 30.7577C28.2883 31.604 28.1237 32.4425 27.8011 33.2249C27.4786 34.0072 27.0045 34.7181 26.4061 35.3165C25.8077 35.9149 25.0968 36.389 24.3144 36.7116C23.532 37.0341 22.6936 37.1987 21.8473 37.1959C21.001 37.193 20.1637 37.0228 19.3835 36.695C18.6033 36.3673 17.8956 35.8884 17.3012 35.286C16.1324 34.0758 15.4856 32.4549 15.5002 30.7725C15.5149 29.0901 16.1897 27.4807 17.3794 26.291C18.5691 25.1013 20.1785 24.4265 21.8609 24.4118C23.5433 24.3972 25.1642 25.044 26.3744 26.2128L26.3756 26.2117ZM26.3756 26.2117L31.1706 21.4167L26.3756 26.2117ZM31.1706 21.4167L34.6706 24.9167L38.7539 20.8333L35.2539 17.3333L31.1706 21.4167Z"
      stroke="#1EA68A"
      stroke-width="2.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const envelope = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="54"
    height="53"
    viewBox="0 0 54 53"
    fill="none"
  >
    <circle cx="27" cy="26.5" r="26.5" fill="#00EFC1" fill-opacity="0.1" />
    <circle cx="27" cy="26.5" r="21.5" fill="#00EFC1" fill-opacity="0.3" />
    <path
      d="M39.1666 19C39.1666 17.7166 38.1166 16.6666 36.8333 16.6666H18.1666C16.8833 16.6666 15.8333 17.7166 15.8333 19M39.1666 19V33C39.1666 34.2833 38.1166 35.3333 36.8333 35.3333H18.1666C16.8833 35.3333 15.8333 34.2833 15.8333 33V19M39.1666 19L27.4999 27.1666L15.8333 19"
      stroke="#1EA68A"
      stroke-width="2.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

function ForgotPassword() {
  const navigate = useNavigate();

  const [page, setPage] = useState(1);
  const [email, setEmail] = useState("");
  const [disableButton, disableSubmitButton] = useState(false);

  const mutation = useMutation(forgetPassword, {
    onSuccess: () => {
      navigate('/passwordreset')
      disableSubmitButton(false);
      setPage(2);
    },
    onError: (e) => {
      showErrorToast(e.message || "An error occurred");
    },
  });

  const forgotPassword = async (e) => {
    e.preventDefault();
    let formData = new FormData(e.target);
    const userEmail = formData.get("email");
    if (!isValidEmail(userEmail)) {
      showErrorToast("Invalid email address");
    }

    setEmail(userEmail);
    localStorage.setItem("ur-sc", userEmail);
    mutation.mutate({ email: userEmail });
  };

  return (
    <div className="font-inter h-screen w-full flex flex-col text-center align-middle items-center bg-white">
      <div className="pt-24 flex flex-col gap-6 items-center">
        <div className="flex justify-center">{page == 1 ? key : envelope}</div>
        <div className="font-inter flex flex-col gap-10 items-center">
          {page == 1 ? (
            <>
              <div>
                <h3 className="text-[30px] font-[700] text-[#101828]">
                  Forgot Password?
                </h3>
                <p className="text-[#667085] text-[16px] font-[400]">
                  No worries, we'll send you reset instructions.
                </p>
              </div>
              <form
                onSubmit={(e) => forgotPassword(e)}
                className="flex flex-col gap-4"
              >
                <div className="flex flex-col gap-1 items-start">
                  <div className="text-[#344054] text-[14px] font-medium">
                    Email
                  </div>
                  <div className="w-fit">
                    <input
                      type="text"
                      className="w-[330px] border-none bg-[#EFF0F6] p-3 rounded-[5px] text-[13px] "
                      placeholder="akpusugh@stown.com"
                      name="email"
                    />
                  </div>
                </div>
                <div className="pt-2 w-full flex">
                  <button
                    disabled={disableButton}
                    type="submit"
                    className={`w-full mx-auto  bg-[#00EFC1] border-none rounded-3xl font-dmsans font-bold text-[15px] text-dark py-3 ${mutation.isLoading ? "animate-pulse" : ""}`}
                  >
                    {mutation.isLoading ? 'Resetting...' : 'Reset password'}
                  </button>
                </div>
              </form>
            </>
          ) : (
            <div className="">
              <div className="font-bold text-[#101828] text-[30px]">
                Check your email
              </div>
              <div className="text-[#667085] text-[15px]">
                We sent a password reset link to <br />
                <span className="font-medium">{email}</span>
              </div>

              <button
                onClick={() => navigate("/passwordreset")}
                className="w-full mx-auto mt-7 bg-[#00EFC1] border-none rounded-3xl font-dmsans font-bold text-[15px] text-dark py-3"
              >
                Continue to Reset Password
              </button>
            </div>
          )}
          <div className="">
            <Link
              to="/login"
              className="text-[14px] font-medium text-[#667085] flex items-center gap-2"
            >
              <HiArrowLeft />
              <span>Back to log in</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export { key, ForgotPassword };
